import type { ExcJpmamV1JpmamTaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const JPMAM_TASK_BASE_PATH = getResolvedPath('/clearing/vendor/jpm/task');

export const getJpmamTaskPath: EntityPathBuilder<ExcJpmamV1JpmamTaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return JPMAM_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jpmamTaskId) {
        return undefined;
      }

      return getResolvedPath(`${JPMAM_TASK_BASE_PATH}/$taskId`, { taskId: context.keys.jpmamTaskId, ...context.keys });
    }
  }
};

export function getJpmamTaskDetailPath(jpmamTaskId: string | undefined) {
  if (!jpmamTaskId) {
    return undefined;
  }

  return getJpmamTaskPath({ kind: 'detail', keys: { jpmamTaskId } });
}
